import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import richTextFieldIconTypes from './richTextFieldIconTypes';
import './RichTextFieldIcon.scss';
import Tooltip from './Tooltip';
var ARTBOARD_SIZE = 32;
var RichTextFieldIcon = function (_a) {
    var className = _a.className, isActive = _a.isActive, isDisabled = _a.isDisabled, onClick = _a.onClick, type = _a.type, props = __rest(_a, ["className", "isActive", "isDisabled", "onClick", "type"]);
    var _b = richTextFieldIconTypes[type], content = _b.content, keyboardShortcut = _b.keyboardShortcut, title = _b.title;
    var iconButtonClassName = classnames('RichTextFieldIcon', {
        'RichTextFieldIcon--isDisabled': isDisabled,
        'RichTextFieldIcon--isInteractive': onClick && !isDisabled,
        'RichTextFieldIcon--isActive': isActive
    }, className);
    return (React.createElement(Tooltip, { content: React.createElement(React.Fragment, null,
            React.createElement("p", { className: 'u-noWrap' }, title),
            keyboardShortcut ? (React.createElement("p", { className: 'u-noWrap' }, keyboardShortcut)) : null) },
        React.createElement("button", __assign({}, props, { className: iconButtonClassName, disabled: isDisabled, onClick: onClick, type: 'button' }),
            React.createElement("svg", { "aria-label": title, className: 'RichTextFieldIcon__svg', role: 'img', viewBox: "0 0 ".concat(ARTBOARD_SIZE, " ").concat(ARTBOARD_SIZE), xmlns: 'http://www.w3.org/2000/svg' }, content))));
};
RichTextFieldIcon.propTypes = {
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(Object.keys(richTextFieldIconTypes))
};
export default RichTextFieldIcon;
//# sourceMappingURL=RichTextFieldIcon.js.map